import { FunctionalComponent } from 'preact'
import { IdeationStatus } from '../../services/unified'

export interface IdeationStatusViewProps {
  ideationStatus: IdeationStatus
}

const IdeationStatusView: FunctionalComponent<IdeationStatusViewProps> = ({
  ideationStatus
}) => (
  <span
    className='topic__content-type-pill pill pill--uppercase pill--idea qa-content-type-pill'
    style={`background-color: ${ideationStatus.bgColor}; color: ${ideationStatus.color};`}
  >
    {ideationStatus.name}
  </span>
)

export default IdeationStatusView
